"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _menuList = _interopRequireDefault(require("./menuList.scss"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MenuList = function MenuList(_ref) {
  var depth = _ref.depth,
      partials = _ref.partials,
      sections = _ref.sections,
      filteredSections = _ref.filteredSections;
  var MenuLink = partials.MenuLink;
  return _react["default"].createElement("ul", null, filteredSections.map(function (section, i) {
    return !section.hidden && _react["default"].createElement("li", {
      key: i
    }, _react["default"].createElement(MenuLink, {
      depth: depth,
      section: section
    }), (0, _utils.inPath)(section.path) && section.sections ? _react["default"].createElement(MenuList, {
      depth: depth + 1,
      filteredSections: section.sections,
      partials: partials
    }) : null);
  }));
};

MenuList.propTypes = {
  partials: _propTypes["default"].shape({
    MenuLink: _propTypes["default"].func.isRequired
  }).isRequired
};
MenuList.defaultProps = {};
var _default = MenuList;
exports["default"] = _default;